export const MessageBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Messages",
    href: "/admin/messages" 
  },
];


export const applicationBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Applications",
    href: "/admin/job-applications" 
  },
];


export const adminUsersBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Users",
    href: "/admin/users" 
  },
];
export const nationalitiesBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Nationalities",
    href: "/admin/nationalities" 
  },
];

export const departmentsBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Departments",
    href: "/admin/departments" 
  },
];
export const trainnesBreadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },
  { 
    title: "Trainees",
    href: "/admin/trainees" 
  },
];
